var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"icon":"fad fa-pencil-ruler","title":"Upravit typ opravy"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('BackLinkButton',{attrs:{"to":"/setup/repair_types"}})]},proxy:true}])}),_c('RepairTypeForm',{attrs:{"request":_vm.request,"is-processing":_vm.isUpdating},on:{"submitted":_vm.onSubmitted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }